module.exports = __webpack_public_path__ + "static/media/customers.f4909530.svg";